import React from "react";
import { SubSection } from "./modules/SubSection/SubSection";
import styles from "./SubSectionWrapperStyles.module.css";
import { hasMenuPermission } from "utils/AuthUtil";
import { useFeatureAccessibility } from "features/Account/utils/useFeatureAccessibility";
import { FEATURE_KEYS } from "features/Account/Account.constants";

export const SubSectionWrapper = ({ section = {} }) => {
  const { customLockSubSection, customWhitelabelLock } = section;

  const { isFeatureAccessible } = useFeatureAccessibility();
  const isWhitelabelActive = isFeatureAccessible({
    featureKey: FEATURE_KEYS.whitelabel,
  });

  const isLocked =
    section.permissionKey && !hasMenuPermission(section.permissionKey);
  const showWhitelabelLock = customWhitelabelLock && !isWhitelabelActive;
  const showLockSection = isLocked || showWhitelabelLock;

  return (
    <div className={styles.wrapper}>
      {showLockSection ? (
        <div className="tw-p-6 tw-overflow-hidden tw-border tw-border-solid tw-border-[#e1e1e1] tw-rounded-md">
          {isLocked ? customLockSubSection : customWhitelabelLock}
        </div>
      ) : (
        section?.subSectionConfig?.map((subSection) => (
          <SubSection key={subSection.key} subSection={subSection} />
        ))
      )}
    </div>
  );
};
